import request from 'api/requestUtils'

export interface LinkPersonalAccountRequest {
  login: string
  password: string
  recaptchaResponse?: string
  businessId: string
}

export async function requestPostLinkPersonalAccount(data: LinkPersonalAccountRequest) {
  return request.post<App.ApiResponse<any>, LinkPersonalAccountRequest>(
    '/api/business-traveller/employees/link-personal-account',
    data,
    { credentials: 'include' },
  )
}
